import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_c5626498 from 'nuxt_plugin_sentryserver_c5626498' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_37955c2c from 'nuxt_plugin_sentryclient_37955c2c' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_portalvue_967bb73a from 'nuxt_plugin_portalvue_967bb73a' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_webfontloader_301e53f0 from 'nuxt_plugin_webfontloader_301e53f0' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_6ca1bd98 from 'nuxt_plugin_cookieuniversalnuxt_6ca1bd98' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_apollomodule_71c04c88 from 'nuxt_plugin_apollomodule_71c04c88' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_cbfc0420 from 'nuxt_plugin_axios_cbfc0420' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_b96a91e8 from 'nuxt_plugin_workbox_b96a91e8' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_5932321f from 'nuxt_plugin_metaplugin_5932321f' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_buefy_5be0fd41 from 'nuxt_plugin_buefy_5be0fd41' // Source: ./buefy.js (mode: 'all')
import nuxt_plugin_moment_962d5cb0 from 'nuxt_plugin_moment_962d5cb0' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_vuegtag_9dc199a0 from 'nuxt_plugin_vuegtag_9dc199a0' // Source: ../plugins/vue-gtag (mode: 'all')
import nuxt_plugin_lodash_52e6a2ea from 'nuxt_plugin_lodash_52e6a2ea' // Source: ../plugins/lodash (mode: 'all')
import nuxt_plugin_filter_68021324 from 'nuxt_plugin_filter_68021324' // Source: ../plugins/filter (mode: 'all')
import nuxt_plugin_globalmixins_415d51c6 from 'nuxt_plugin_globalmixins_415d51c6' // Source: ../plugins/global-mixins (mode: 'all')
import nuxt_plugin_globalcomponent_1536fa6e from 'nuxt_plugin_globalcomponent_1536fa6e' // Source: ../plugins/global-component (mode: 'all')
import nuxt_plugin_vuei18n_5a00aec8 from 'nuxt_plugin_vuei18n_5a00aec8' // Source: ../plugins/vue-i18n.js (mode: 'all')
import nuxt_plugin_vueerrorprocessor_1284b332 from 'nuxt_plugin_vueerrorprocessor_1284b332' // Source: ../plugins/vue-error-processor.js (mode: 'client')
import nuxt_plugin_vueslidercomponent_6d7bde24 from 'nuxt_plugin_vueslidercomponent_6d7bde24' // Source: ../plugins/vue-slider-component (mode: 'client')
import nuxt_plugin_vueagile_726cdbff from 'nuxt_plugin_vueagile_726cdbff' // Source: ../plugins/vue-agile (mode: 'client')
import nuxt_plugin_vuejsdatepicker_9fb8794e from 'nuxt_plugin_vuejsdatepicker_9fb8794e' // Source: ../plugins/vuejs-date-picker (mode: 'client')
import nuxt_plugin_vuemodalmessage_0efd782a from 'nuxt_plugin_vuemodalmessage_0efd782a' // Source: ../plugins/vue-modal-message (mode: 'client')
import nuxt_plugin_vuesnackbar_7c1493e2 from 'nuxt_plugin_vuesnackbar_7c1493e2' // Source: ../plugins/vue-snackbar (mode: 'client')
import nuxt_plugin_nuxtvideoplayerplugin_7826a9de from 'nuxt_plugin_nuxtvideoplayerplugin_7826a9de' // Source: ../plugins/nuxt-video-player-plugin.js (mode: 'client')
import nuxt_plugin_vuecropper_078e3210 from 'nuxt_plugin_vuecropper_078e3210' // Source: ../plugins/vue-cropper (mode: 'client')
import nuxt_plugin_directives_521c0486 from 'nuxt_plugin_directives_521c0486' // Source: ../plugins/directives.js (mode: 'client')
import nuxt_plugin_smoothscroll_ac9d6bbe from 'nuxt_plugin_smoothscroll_ac9d6bbe' // Source: ../plugins/smooth-scroll.js (mode: 'client')
import nuxt_plugin_simplebar_28d69fac from 'nuxt_plugin_simplebar_28d69fac' // Source: ../plugins/simplebar.js (mode: 'client')
import nuxt_plugin_vuemodallightbox_275cb532 from 'nuxt_plugin_vuemodallightbox_275cb532' // Source: ../plugins/vue-modal-lightbox (mode: 'client')
import nuxt_plugin_toaster_70c3bc59 from 'nuxt_plugin_toaster_70c3bc59' // Source: ../plugins/toaster.js (mode: 'client')
import nuxt_plugin_validationprovider_53910e08 from 'nuxt_plugin_validationprovider_53910e08' // Source: ../plugins/validation-provider.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Academy Training","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Professional development on the go! Personalised learning for teachers to upgrade their skills"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Nunito+Sans:400,600,700|Nunito:600,800&display=swap","rel":"stylesheet"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Ffont-awesome\u002F5.8.2\u002Fcss\u002Fall.min.css"},{"type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@5.8.55\u002Fcss\u002Fmaterialdesignicons.min.css","rel":"preload","as":"style","onload":"this.rel='stylesheet'"}],"script":[{"src":"\u002Fdist\u002Fscorm-again.min.js"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_c5626498 === 'function') {
    await nuxt_plugin_sentryserver_c5626498(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_37955c2c === 'function') {
    await nuxt_plugin_sentryclient_37955c2c(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_967bb73a === 'function') {
    await nuxt_plugin_portalvue_967bb73a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_301e53f0 === 'function') {
    await nuxt_plugin_webfontloader_301e53f0(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_6ca1bd98 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_6ca1bd98(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_71c04c88 === 'function') {
    await nuxt_plugin_apollomodule_71c04c88(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_cbfc0420 === 'function') {
    await nuxt_plugin_axios_cbfc0420(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_b96a91e8 === 'function') {
    await nuxt_plugin_workbox_b96a91e8(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_5932321f === 'function') {
    await nuxt_plugin_metaplugin_5932321f(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_5be0fd41 === 'function') {
    await nuxt_plugin_buefy_5be0fd41(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_962d5cb0 === 'function') {
    await nuxt_plugin_moment_962d5cb0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuegtag_9dc199a0 === 'function') {
    await nuxt_plugin_vuegtag_9dc199a0(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_52e6a2ea === 'function') {
    await nuxt_plugin_lodash_52e6a2ea(app.context, inject)
  }

  if (typeof nuxt_plugin_filter_68021324 === 'function') {
    await nuxt_plugin_filter_68021324(app.context, inject)
  }

  if (typeof nuxt_plugin_globalmixins_415d51c6 === 'function') {
    await nuxt_plugin_globalmixins_415d51c6(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponent_1536fa6e === 'function') {
    await nuxt_plugin_globalcomponent_1536fa6e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuei18n_5a00aec8 === 'function') {
    await nuxt_plugin_vuei18n_5a00aec8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueerrorprocessor_1284b332 === 'function') {
    await nuxt_plugin_vueerrorprocessor_1284b332(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueslidercomponent_6d7bde24 === 'function') {
    await nuxt_plugin_vueslidercomponent_6d7bde24(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueagile_726cdbff === 'function') {
    await nuxt_plugin_vueagile_726cdbff(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsdatepicker_9fb8794e === 'function') {
    await nuxt_plugin_vuejsdatepicker_9fb8794e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemodalmessage_0efd782a === 'function') {
    await nuxt_plugin_vuemodalmessage_0efd782a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesnackbar_7c1493e2 === 'function') {
    await nuxt_plugin_vuesnackbar_7c1493e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtvideoplayerplugin_7826a9de === 'function') {
    await nuxt_plugin_nuxtvideoplayerplugin_7826a9de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecropper_078e3210 === 'function') {
    await nuxt_plugin_vuecropper_078e3210(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directives_521c0486 === 'function') {
    await nuxt_plugin_directives_521c0486(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_smoothscroll_ac9d6bbe === 'function') {
    await nuxt_plugin_smoothscroll_ac9d6bbe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_simplebar_28d69fac === 'function') {
    await nuxt_plugin_simplebar_28d69fac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemodallightbox_275cb532 === 'function') {
    await nuxt_plugin_vuemodallightbox_275cb532(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toaster_70c3bc59 === 'function') {
    await nuxt_plugin_toaster_70c3bc59(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_validationprovider_53910e08 === 'function') {
    await nuxt_plugin_validationprovider_53910e08(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
